'use client';
import { usePathname } from "next/navigation";
import AppLayout from "@/layouts/AppLayout";
import { fetchCartFx, fetchFavoritesFx } from "@/shared/store/shop";
import { useEffect } from "react";

export default function LayoutWrapper({ headerBanner, children }: { headerBanner: React.ReactNode,children: React.ReactNode }) {
  const pathname = usePathname();
  const isAdmin = pathname.includes("/admin");

  useEffect(() => {
    fetchCartFx();
    fetchFavoritesFx();
  }, []);

  return isAdmin ? <>{children}</> : <AppLayout headerBanner={headerBanner}>{children}</AppLayout>;
}